import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { UserMerchant, UserProfile } from '../request/type';

interface State {
	token: string | null;
	id: number;
	name: string;
	username: string;
	phone: string;
	apiKey: string;
	smsUnitBalance: number;
	role: string;
	accountNonExpired: boolean;
	accountNonLocked: boolean;
	credentialsNonExpired: boolean;
	enabled: boolean;
	passwordReset: boolean;
	senderIds: string;
	// merchant: UserMerchant;
	merchantId: number;
	merchantSMSUnitBalance: number;
}

const initialState: State = {
	token: null,
	id: 0,
	name: '',
	username: '',
	phone: '',
	apiKey: '',
	smsUnitBalance: 0,
	role: '',
	accountNonExpired: false,
	accountNonLocked: false,
	credentialsNonExpired: false,
	enabled: false,
	passwordReset: false,
	senderIds: '',
	// merchant: {
	// 	id: 0,
	// 	name: '',
	// 	smsUnitBalance: 0,
	// 	accountType: '',
	// 	messagingPrefix: ""
	// },
	merchantId: 0,
	merchantSMSUnitBalance: 0,
};

export const userSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		login: (state: State, action: PayloadAction<string>) => {
			state.token = action?.payload ?? state?.token;
		},
		updateUserProfile: (state: State, action: PayloadAction<UserProfile>) => {
			state.id = action?.payload?.id ?? state?.id;
			state.name = action?.payload?.name ?? state.name;
			state.username = action?.payload?.username ?? state?.username;
			state.phone = action?.payload?.phone ?? state?.phone;
			state.apiKey = action?.payload?.apiKey ?? state?.apiKey;
			state.smsUnitBalance = action?.payload?.smsUnitBalance ?? state?.smsUnitBalance;
			state.role = action?.payload?.role ?? state?.role;
			state.accountNonExpired = action?.payload?.accountNonExpired ?? state?.accountNonExpired;
			state.credentialsNonExpired = action?.payload?.credentialsNonExpired ?? state?.credentialsNonExpired;
			state.enabled = action?.payload?.enabled ?? state?.enabled;
			state.passwordReset = action?.payload?.passwordReset ?? state?.passwordReset;
			state.senderIds = action?.payload?.senderIds ?? state?.senderIds;
			state.merchantId = action?.payload?.merchant?.id ?? state?.merchantId;
			state.merchantSMSUnitBalance = action?.payload?.merchant?.smsUnitBalance ?? state?.merchantSMSUnitBalance;
		},

		logout: (state: State) => {
			state.token = null;
			state.id = 0;
			state.name = '';
			state.username = '';
			state.phone = '';
			state.apiKey = '';
			state.smsUnitBalance = 0;
			state.role = '';
			state.accountNonExpired = false;
			state.accountNonLocked = false;
			state.credentialsNonExpired = false;
			state.enabled = false;
			state.passwordReset = false;
			state.merchantId = 0;
			state.senderIds = '';
			state.merchantSMSUnitBalance = 0;
			window.location.replace('/');
		},
	},
});

export const { login, logout, updateUserProfile } = userSlice.actions;
export default userSlice.reducer;
